export default {
	props: {
    staticTitle: {
      type: String,
      default: 'Overview'
    },
    staticSubTitle: String,
    staticCopy: String,
    buttonsGroup: Boolean,
    staticImage: Boolean
	},

	data() {
    return {
 
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/static-page/static-info-left-image/static-info-left-image.js